import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetJackpotList} from '../../store/thunk/setGetJackpotList';
import TemplatePage from '../../../components/templatePage';
import JackpotItem from '../../components/jackpotItem';

const JackpotList = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetJackpotList());
    }, [])

    const list = useSelector(state => state.jackpotMobile.list_jackpot);

    return (
        <TemplatePage
            title="Список Джекпотов"
        >
            {
                list.map((item) => <JackpotItem item={item}/>)
            }
        </TemplatePage>
    )
}

export default JackpotList;